import { Col, Edit, Form, Input, ListButton, Row, Space, notification } from '@pankod/refine-antd';
import { useNavigation } from '@pankod/refine-core';
import { useParams } from '@pankod/refine-react-router-v6';
import { useEffect, useState } from 'react';
import { getMeasurementUnit, updateMeasurementUnit } from 'services/measurement-units';

export const MeasurementUnitEdit: React.FC = () => {
  const [isFetching, setIsFetching] = useState<boolean>(false);
  const [isUpdating, setIsUpdating] = useState<boolean>(false);
  const { id: measurementUnitId } = useParams();

  const [form] = Form.useForm();
  const { push } = useNavigation();

  useEffect(() => {
    if (!measurementUnitId) return;

    (async () => {
      try {
        setIsFetching(true);
        const data = await getMeasurementUnit(measurementUnitId);
        form.setFieldsValue({
          name: data.name,
          abbreviation: data.abbreviation,
          description: data.description,
        });
      } catch (err: any) {
        console.error(err.message);
        notification.error({
          message: 'Failed',
          description: err?.message,
        });
      } finally {
        setIsFetching(false);
      }
    })();
  }, [form, measurementUnitId]);

  const onFinish = async (values: any) => {
    if (!measurementUnitId) return;

    setIsUpdating(true);
    try {
      await updateMeasurementUnit(measurementUnitId, {
        ...values,
        description: values.description ?? null,
      });
      notification.success({
        message: 'Success',
        description: 'Updated successfully.',
      });
      push('/measurement-units');
    } catch (err: any) {
      console.error(err?.message);
      notification.error({
        message: 'Failed',
        description: err?.message,
      });
    }
    setIsUpdating(false);
  };

  const pageHeaders = (
    <Space>
      <ListButton />
    </Space>
  );

  return (
    <Edit
      isLoading={isFetching}
      headerProps={{ extra: pageHeaders }}
      saveButtonProps={{
        disabled: isUpdating,
        loading: isUpdating,
        onClick: form.submit,
      }}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={{
          isActive: true,
        }}
        onFinish={onFinish}
      >
        <Row justify="space-around" align="middle">
          <Col xs={24} lg={12}>
            <Form.Item
              label="Name"
              name="name"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              label="Abbreviation"
              name="abbreviation"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item label="Description" name="description">
              <Input.TextArea rows={3} />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Edit>
  );
};
